import { render } from "./FormArrayValues.vue?vue&type=template&id=0701b5cf"
import script from "./FormArrayValues.vue?vue&type=script&lang=js"
export * from "./FormArrayValues.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__